import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface TrendData {
  date: string;
  progress: number;
  completions: number;
}

interface ProgressTrendChartProps {
  data: TrendData[];
}

const ProgressTrendChart: React.FC<ProgressTrendChartProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <div className="flex items-center justify-center h-[300px] text-muted-foreground">
        No progress trend data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line 
          type="monotone" 
          dataKey="progress" 
          stroke="hsl(var(--primary))" 
          strokeWidth={2}
          name="Avg Progress (%)"
        />
        <Line 
          type="monotone" 
          dataKey="completions" 
          stroke="hsl(var(--success))" 
          strokeWidth={2}
          name="Completions"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ProgressTrendChart;
